import { inject, provideAppInitializer } from '@angular/core';

import { Store } from '@ngrx/store';

import { customParameterActions } from '@app/core/store/custom-parameter/custom-parameter.actions';

export const customParameterFactory = (store: Store): () => void => () =>
  new Promise<void>((resolve) => {
    store.dispatch(customParameterActions.loadCustomParameters());
    resolve();
  });

export const customParameterInitializer = provideAppInitializer(() => {
        const initializerFn = (customParameterFactory)(inject(Store));
        return initializerFn();
      });
